import { getAppointmentGroup } from "app/redux/appointmentGroupsSlice";
import { useQuery } from "app/utils/useQuery";
import { addMinutes } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

// Calendar times in UTC ("Z"), which every calendar app places correctly. The file used to subtract the
// zone's fixed offset (ignoring daylight time) and label the result with the viewer's zone, so a 10 AM
// Pacific appointment landed at 6 PM in the shop's calendar and on the next morning from India.
export const icsUtc = (date: Date | string) => formatInTimeZone(new Date(date), "UTC", "yyyyMMdd'T'HHmmss'Z'");

export const useConfirmAppointment = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const isReschedule = query.get("reschedule") === "true";
  const { appointmentGroupId } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [appointmentGroup, setAppointmentGroup] = React.useState<any>(null);

  const generateICSFile = () => {
    const { appointments, startTime, duration, updatedAt } = appointmentGroup;
    const endTime = addMinutes(new Date(startTime), duration);
    const location = appointments[0]?.shop.addressLine1;
    const client = appointments[0]?.client.name;

    const sequence = Math.floor(new Date(updatedAt).getTime() / 1000); // Convert to seconds since epoch
    const uid = `${appointmentGroup.id}@heyallset.com`;
    const dtStamp = icsUtc(new Date());

    const escapeText = (text: string) =>
      text.replace(/,/g, "\\,").replace(/;/g, "\\;").replace(/\n/g, "\\n");

    const icsContent = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "BEGIN:VEVENT",
      `UID:${uid}`,
      `SEQUENCE:${sequence}`,
      `DTSTAMP:${dtStamp}`,
      `SUMMARY:${escapeText(
        `${isReschedule ? "UPDATED" : ""}Appointment with ${client}`
      )}`,
      `DESCRIPTION:${escapeText(`${appointments[0].services[0].title}`)}`,
      `LOCATION:${escapeText(location)}`,
      `DTSTART:${icsUtc(startTime)}`,
      `DTEND:${icsUtc(endTime)}`,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n"); // Ensure proper line endings

    const blob = new Blob([icsContent], { type: "text/calendar" });
    // return URL.createObjectURL(blob);
    const icsUrl = URL.createObjectURL(blob);

    // Attempt to open the file
    window.open(icsUrl, "_blank");

    // Clean up the URL object after some time
    setTimeout(() => {
      URL.revokeObjectURL(icsUrl);
    }, 5000);
  };

  const init = async () => {
    setLoading(true);
    try {
      const ag = await dispatch(
        getAppointmentGroup(Number(appointmentGroupId)) as any
      ).unwrap();
      setAppointmentGroup(ag);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return {
    loading,
    appointmentGroup,
    generateICSFile,
    isReschedule,
  };
};
